import { isSSR } from '@k2/core/util'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useApiRequest } from '@/api'
import { useCampaignReferencesResource } from '../resources'

export type CampaignReference = { assetId: string; name: string | null; url: string; thumbnailUrl: string | null }

export const useCampaignReferenceStore = defineStore('campaignReference', () => {
  const { getProductPhoto, setProductPhoto } = useCampaignReferencesResource()
  const { run, loading, failure } = useApiRequest()

  const productPhotos = ref<Record<string, CampaignReference | null>>({})

  const load = async (organizationId: string, campaignId: string) => {
    if (isSSR) return
    const found = await run<{ photo: CampaignReference | null }>(() => getProductPhoto(organizationId, campaignId))
    if (found) productPhotos.value = { ...productPhotos.value, [campaignId]: found.photo }
  }

  const uploadProductPhoto = async (organizationId: string, campaignId: string, file: File) => {
    const stored = await run<CampaignReference>(() => setProductPhoto(organizationId, campaignId, file))
    if (stored) productPhotos.value = { ...productPhotos.value, [campaignId]: stored }
  }

  return { productPhotos, loading, failure, load, uploadProductPhoto }
})
